import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useState } from 'react';
import { Button, ButtonGroup } from '@mui/material';

export const colocarNombre = (ruta) => {
    if (!ruta || ruta === '')
        return ''
    const indice = Number(ruta.indexOf("factura")) + 9
    return ruta.slice(indice)

}

function Row(props) {
    const { row, gastos, setGastos, facturasEliminadas, setFacturasEliminadas } = props;
    const [open, setOpen] = useState(true);

    const handleDeleteRegistrado = async (registro) => {
        //console.log(`registro ${JSON.stringify(registro)}`)

        // borrar las facturas registradas 
        //try {     
        /*  if(registro.id){     
        const resDelete = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/gastoCC/${registro.id}`, {
          method: "DELETE",
          headers: {
            "x-access-token": sessionStorage.getItem('token'),
            "perfil": sessionStorage.getItem('perfil')
          }
        })

        if(resDelete.status === 200){  */
        //Solo se eliminará del listado, el procesamiento se realizará en el update    
        row.monto = Number(Number(row.monto ? row.monto : 0) - Number(registro.monto)).toFixed(2)
        if (registro.id) {
            row.facturaAEs = row.facturaAEs.filter(comprobanteG => comprobanteG.id !== registro.id)
            facturasEliminadas.push(registro)
            setFacturasEliminadas(facturasEliminadas.concat([]))
        }
        else
            row.facturaAEs = row.facturaAEs.filter(comprobanteG => comprobanteG.indice !== registro.indice)
        setGastos(gastos.concat([]))
        /*}
      }
      else{
          row.facturaAEs = row.facturaAEs.filter(comprobanteG => comprobanteG.id !== registro.id)
          setGastos(gastos.concat([]))
      }*/

        /*} catch (error) {
          console.log(error)
        }*/
    }

    return (
        <>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: 'rgba(25, 118, 210, 0.08)' }}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>

                <TableCell align="left" scope="row" sx={{ fontWeight: 800 }}>{row.partida}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 800 }}>${Number(row.monto).toFixed(2)}</TableCell>
                <TableCell style={{ width: '130px' }}></TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Typography variant="subtitle2" gutterBottom component="div">
                                Comprobantes / Facturas
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>PDF</TableCell>
                                        <TableCell>XML</TableCell>
                                        <TableCell align="right">Monto</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.facturaAEs ? row.facturaAEs.map((comprobante) => (
                                        <TableRow key={comprobante.id ? comprobante.id : comprobante.indice}>
                                            <TableCell component="th" scope="row">
                                                {comprobante.rutaPDF ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(comprobante.rutaPDF)}`} download={colocarNombre(comprobante.rutaPDF)}>{colocarNombre(comprobante.rutaPDF)}</Button> : `${comprobante.documentos.get('PDF').name}`}
                                            </TableCell>
                                            <TableCell>{comprobante.rutaXML ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(comprobante.rutaXML)}`} download={colocarNombre(comprobante.rutaXML)}>{colocarNombre(comprobante.rutaXML)}</Button> : `${comprobante.documentos ? comprobante.documentos.get('XML') ? comprobante.documentos.get('XML').name : '' : ''}`}</TableCell>
                                            <TableCell align="right">${Number(comprobante.monto).toFixed(2)}</TableCell>
                                            <TableCell align="left" style={{ width: 20 }}>
                                                <ButtonGroup disableElevation variant="outlined" color="primary">
                                                    <Button variant='contained' style={{ marginLeft: 5, backgroundColor: "darkred", color: 'white' }} onClick={() => handleDeleteRegistrado(comprobante)}>{'Eliminar'}</Button>
                                                </ButtonGroup>
                                            </TableCell>
                                        </TableRow>
                                    )) : <></>
                                    }
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

Row.propTypes = {
    row: PropTypes.shape({
        partida: PropTypes.string.isRequired,
        monto: PropTypes.string.isRequired,
        facturaAEs: PropTypes.arrayOf(
            PropTypes.shape({
                rutaPDF: PropTypes.string,
                rutaXML: PropTypes.string,
                monto: PropTypes.number.isRequired,
            }),
        ).isRequired,
    }).isRequired,
};


export default function AEPartidasListado(props) {
    const { gastos, setGastos, setSinComprobantes, facturasEliminadas, setFacturasEliminadas } = props;

    const rows = gastos
    return (
        <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Partida</TableCell>
                        <TableCell align="right">Monto</TableCell>
                        <TableCell style={{ width: 40 }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <Row key={row.id ? row.id : row.indice} row={row} gastos={gastos} setGastos={setGastos} setSinComprobantes={setSinComprobantes} facturasEliminadas={facturasEliminadas} setFacturasEliminadas={setFacturasEliminadas} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}